// Authentication starts before there is a session, so every return path is
// untrusted. Keep the browser's routing decisions aligned with the backend's
// safeReturnPath helpers: only an app-local absolute path may survive.
export function safeReturnPath(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/'
  return value
}

export function returnPathFromSearch(search: string): string {
  return safeReturnPath(new URLSearchParams(search).get('next'))
}

export function pathWithReturnTo(path: string, returnTo: string): string {
  return returnTo === '/' ? path : `${path}?next=${encodeURIComponent(returnTo)}`
}
